import { endpoints } from '../endpoints'
import { http } from '../http'
import { VisitorUser } from '../../types'

interface VisitorUserParams {
  email: string
  name: string
  location?: string
}

export const visitorUsers = {
  create: (params: VisitorUserParams): Promise<VisitorUser> =>
    http.post(endpoints.visitorUsers, { visitor_user: params }),
}
